import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Colors from './Colors.js';
import { firebaseRef } from '../firebase.js';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

class Inputcheckbox extends Component {
  constructor(props){
    super(props);
    this.state = {
      colors: false,
      colorChoosen: '',
    };
    this.colorsShow = this.colorsShow.bind(this);
    this.click = this.click.bind(this);
  }

  componentWillMount(){
    var that=this;
    var user = this.props.match.params.user;
    var doctor = this.props.match.params.doctor;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user+'/levels/'+this.props.title);
    refMain.on('child_added', (datasnapShot) =>{
      that.setState({ colorChoosen: datasnapShot.val() });
    });
  }

  colorsShow(){
    this.setState({ colors: !this.state.colors });
  }

  click(event){
    if (event.target.title === 'clear') {
        this.setState({ colorChoosen: '', colors: false });
    }else{
        this.setState({ colorChoosen: event.target.title, colors: false});
    }
    this.props.levels(this.props, event);
  }

  render() {
    const {title} = this.props;
    return (
      <div className={`levels-title ${this.state.colorChoosen}`}>
      <ReactCSSTransitionGroup
        transitionName="example"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}>
      {this.state.colors ? <Colors click={this.click} outClick={this.colorsShow}/> : ''}
      </ReactCSSTransitionGroup>
        <div className="label-container">
          <label htmlFor={title} className="input-label-checkbox"></label>
          <input type="checkbox" name="levels" value={title} className="user-inputs user-inputs-radio" id={title} onClick={this.colorsShow}/>
        </div>

        </div>

    );
  }
}

export default withRouter(Inputcheckbox);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Inputcheckbox.js